// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  stateId: __t.u64().primaryKey().name("state_id"),
  epoch: __t.u64(),
  systemId: __t.string().name("system_id"),
  grip: __t.i32(),
  bossDown: __t.bool().name("boss_down"),
  updatedAt: __t.timestamp().name("updated_at"),
});
